import React from "react";
import styles from "./index.module.css";
import QrCode from "../../Builder/LeftContainer/Posts";
import { isIOS, isWindows, isAndroid, isMacOs } from "react-device-detect";
const index = () => {
    const appURL =
        isIOS || isMacOs
            ? "https://apps.apple.com/in/app/faym/id6479986552"
            : "https://play.google.com/store/apps/details?id=com.application.faym";
    const handleClick = () => {
        window.open(appURL, "_blank");
    };
    return (
        <div className={styles.postsContainer}>
            <span>To access this feature download the Faym App</span>
            <div className={styles.download} onClick={handleClick}>
                Download Now
            </div>
        </div>
    );
};

export default index;
